// ─── ExamplesModal ───────────────────────────────────────────────────────
// Modal overlay che ospita ExamplesPanel. Aperto dalla sidebar
// "Carica esempi" tramite il fragment #esempi sull'URL. Mostra TUTTI gli
// esempi del tenant (nessun filtro per content_format), così l'utente può
// scegliere quale caricare prima ancora di selezionare la modalità.

import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import ExamplesPanel from './ExamplesPanel.jsx';

const ExamplesModal = ({ tenant, onSelect, onClose, t, color }) => {
  // ESC-to-close
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 200,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        padding: 'clamp(16px, 4vw, 48px)',
        overflowY: 'auto',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: t.bg, color: t.text,
          borderRadius: '16px', border: `1px solid ${t.border}`,
          maxWidth: '900px', width: '100%',
          padding: '20px 24px', marginTop: '40px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: t.text }}>
            Carica esempi
          </h2>
          <button
            onClick={onClose}
            aria-label="Chiudi"
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: t.textMuted, padding: '6px', display: 'flex',
            }}
          >
            <X size={20} />
          </button>
        </div>
        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: t.textMuted, lineHeight: 1.5 }}>
          Scegli un esempio pre-compilato per riempire automaticamente i campi del form.
        </p>
        <ExamplesPanel
          tenant={tenant}
          onSelect={onSelect}
          t={t}
          color={color}
        />
      </div>
    </div>
  );
};

export default ExamplesModal;
